import moment from 'moment-timezone';

import React from 'react';

import { Link } from 'react-router-dom';

export const columnName = {
  path: 'name',
  link: '/shipping/imports/:_id',
};

export const columnStore = {
  title: 'Store',
  path: 'store.name',
  render: (record) => (
    record.store?.name
    ? (
      <Link to={`/stores/${record.store._id}`}>
        {record.store.name}
      </Link>
    )
    : '-'
  ),
};

export const columnStatus = {
  path: 'done',
  title: 'Status',
  render: record => (
    !record.ready
    ? 'Awaiting Confirmation'
    : record.done
    ? 'Done'
    : 'Processing'
  ),
};

export const columnCreatedAt = {
  path: 'createdAt',
  title: 'Submitted At',
  render: record => (
    moment(record.createdAt).format(
      'llll'
    )
  ),
};

export const columnCompany = {
  path: 'company',
  title: 'Company',
  render: record => (
    record.company?.name
    ? (
        <Link to={`/shipping/companies/${record.company._id}`}>
          {record.company.name}
        </Link>
      )
    : 'N/A'
  ),
};

export const columnCreatedBy = {
  path: 'createdBy',
  title: 'Submitted By',
  render: record => (
    record.createdBy?.name
    ? (
        <Link to={`/users/${record.createdBy._id}`}>
          {record.createdBy.name}
        </Link>
      )
    : 'N/A'
  ),
};

export const ADMIN = [
  columnName,
  columnStore,
  columnStatus,
  columnCompany,
  columnCreatedAt,
  columnCreatedBy,
];
